export type IMaskZipCodes = IDCA.IGenericFunc;

export function _maskZipCodes(): void {
  const options = {
    onKeyPress(cep: any, event: any, currentField: any, opts: any) {
      // console.log('An key was pressed!:', cep, ' event: ', event, 'currentField: ', currentField, ' options: ', options);
      $(currentField).val(($(currentField).val() as string).toUpperCase());
    },
    translation: {
      A: { pattern: /[A-Za-z]/ },
      N: { pattern: /[0-9]/ },
    },
    // onComplete: function(cep) {
    //  alert('CEP Completed!:' + cep);
    // },
    // onChange: function(cep){
    //  console.log('cep changed! ', cep);
    // },
    // onInvalid: function(val, e, f, invalid, options){
    //  var error = invalid[0];
    //  console.log ("Digit: ", error.v, " is invalid for the position: ", error.p, ". We expect something like: ", error.e);
    // }
  };

  $('input.code-postal-field').each((_, input) => {
    const $input = $(input);
    const mask = $input.data('field-mask') || 'ANA NAN';
    ($input as any).mask(mask, options);
  });
}
